import { FieldInputProps, useField, useFormikContext } from "formik";
import React, { useEffect } from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { BasicInput } from "../BasicInput/BasicInput";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { ReadOnlyTextField } from "../ReadOnlyTextField/ReadOnlyTextField";
import { useSetFieldTouched } from "../useSetFieldTouched";
import * as embeddedStyles from "./EmbeddedOtherTextField.module.css";

export type EmbeddedOtherTextFieldProps = Readonly<{
  name: string;
  maxLength?: number;
  type?: "number" | "string";
  isStringNumber?: boolean;
  onlyInternalElements?: boolean;
  parentChecked?: boolean | undefined;
  // eslint-disable-next-line
  customOnBlur?: (e: React.ChangeEvent<HTMLInputElement>, field: FieldInputProps<any>) => void;
  // eslint-disable-next-line
  customOnChange?: (e: React.ChangeEvent<HTMLInputElement>, field: FieldInputProps<any>) => void;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const EmbeddedOtherTextField = (props: EmbeddedOtherTextFieldProps) => {
  const [field] = useField(props);
  useSetFieldTouched(field.name);
  const { setFieldValue } = useFormikContext();
  const [nameField] = useField({
    name: props.name,
  });

  useEffect(() => {
    if (nameField.name === "genreOther" || nameField.name === "releasedPlatformsOther") {
      if (props.parentChecked === false && field.value !== "") {
        setFieldValue(field.name, "");
      }
    }
  }, [field, field.name, field.value, nameField, props.parentChecked, setFieldValue]);

  const { disabled, isRequiredField } = props;
  return (
    <Row className={embeddedStyles.container}>
      <Column>
        {disabled && <ReadOnlyTextField name={field.name} />}
        {!disabled && (
          <div className={embeddedStyles.otherInputContainer}>
            {isRequiredField && <span className={embeddedStyles.requiredStar}>*</span>}
            <BasicInput {...props} customInputClass={embeddedStyles.textFieldText} />
          </div>
        )}
        <FieldErrorMessage fieldName={field.name} />
      </Column>
    </Row>
  );
};
